// Easy Discounts Table — Base skin (caption & description removed)
// - Viền + nền header + line dùng CHUNG 1 màu (lấy từ Header background)
// - Ẩn hoàn toàn <caption> và xóa "Table description" nếu app render
// - Giữ các tùy chọn còn lại: size, text align, row/column borders, highlight giá cuối

document.addEventListener('DOMContentLoaded', function () {
  const settings = (window.Shopify && window.Shopify.theme && window.Shopify.theme.settings) || {};
  if (!settings.easy_discounts_enable_custom_style) return;

  function applyUnifiedSkin() {
    const containers = document.querySelectorAll(
      '[id*="easy-discounts-table"], div[id^="easy-discounts-table-"]'
    );

    containers.forEach((container) => {
      const table = container.querySelector('table');
      if (!table) return;

      // XÓA "Table description" (khung text) nếu app render
      removeDescription(container, table);

      // Lớp bảng theo logic theme
      table.className = 'table';
      const tableStyle = settings.easy_discounts_table_style || 'bordered'; // minimal | bordered | striped
      if (tableStyle === 'bordered') table.classList.add('table--bordered');
      else if (tableStyle === 'striped') table.classList.add('table--striped');

      const tableSize = settings.easy_discounts_table_size || 'medium'; // small | medium | large
      if (tableSize === 'small') table.classList.add('table--sm');
      else if (tableSize === 'large') table.classList.add('table--lg');

      // Đảm bảo 1 thẻ <style>
      const styleId = 'easy-discounts-dynamic-styles';
      let styleElement = document.getElementById(styleId);
      if (!styleElement) {
        styleElement = document.createElement('style');
        styleElement.id = styleId;
        document.head.appendChild(styleElement);
      }

      // ===== Biến từ settings (màu hợp nhất lấy từ header_bg) =====
      const textAlign = settings.easy_discounts_text_align || 'center';
      const fullWidth = settings.easy_discounts_full_width !== false;

      const showRowBorders = settings.easy_discounts_show_row_borders !== false;     // default: true
      const showColumnBorders = settings.easy_discounts_show_column_borders === true; // default: false

      const highlightDiscount = settings.easy_discounts_highlight_discount !== false;
      const priceColor = settings.easy_discounts_discount_color || '#B64400';

      // MÀU CHUNG: dùng Header background
      const unifiedColor =
        (settings.easy_discounts_header_bg && String(settings.easy_discounts_header_bg).trim()) ||
        '#F6F6F6';

      const borderWidth = Number.isFinite(settings.easy_discounts_border_width)
        ? settings.easy_discounts_border_width
        : 2;
      const borderStyle = settings.easy_discounts_border_style || 'solid';
      const borderRadius = Number.isFinite(settings.easy_discounts_border_radius)
        ? settings.easy_discounts_border_radius
        : 10;
      const innerRadius = Math.max(0, borderRadius - borderWidth);

      const headerText = settings.easy_discounts_header_text || '#666666';

      // Padding theo size
      let padding = 'var(--spacing-3)';
      if (tableSize === 'small') padding = 'var(--spacing-2)';
      else if (tableSize === 'large') padding = 'var(--spacing-4)';

      // ===== CSS =====
      let css = `
/* =================== Easy Discounts — Unified Color Skin =================== */
[id*="easy-discounts-table"] table,
div[id^="easy-discounts-table-"] table {
  width: ${fullWidth ? '100%' : 'auto'} !important;
  margin: var(--spacing-5) ${fullWidth ? '0' : 'auto'} !important;

  /* Viền ngoài bằng inset để ổn định khi overlay header */
  border: 0 !important;
  border-radius: ${borderRadius}px !important;
  box-shadow: inset 0 0 0 ${borderWidth}px ${unifiedColor} !important;

  overflow: hidden !important;
  border-collapse: separate !important;
  border-spacing: 0 !important;
}

/* ẨN caption vĩnh viễn */
[id*="easy-discounts-table"] caption,
div[id^="easy-discounts-table-"] caption {
  display: none !important;
}

/* Header overlay dùng màu hợp nhất */
[id*="easy-discounts-table"] thead,
div[id^="easy-discounts-table-"] thead {
  position: relative !important;
  z-index: 0 !important;
  background: transparent !important;
}
[id*="easy-discounts-table"] thead::before,
div[id^="easy-discounts-table-"] thead::before {
  content: "" !important;
  position: absolute !important;
  inset: 0 !important;
  background: ${unifiedColor} !important;
  border-top-left-radius: ${innerRadius}px !important;
  border-top-right-radius: ${innerRadius}px !important;
  z-index: -1 !important;
  pointer-events: none !important;
}
/* Vá mép phải chống “vệt” anti-aliasing */
[id*="easy-discounts-table"] thead::after,
div[id^="easy-discounts-table-"] thead::after {
  content: "" !important;
  position: absolute !important;
  top: 0; right: 0; bottom: 0;
  width: ${borderWidth}px !important;
  background: ${unifiedColor} !important;
  border-top-right-radius: ${innerRadius}px !important;
  z-index: -1 !important;
  pointer-events: none !important;
}

/* Đường mảnh dưới header */
[id*="easy-discounts-table"] thead tr,
div[id^="easy-discounts-table-"] thead tr {
  border-bottom: 1px ${borderStyle} ${unifiedColor} !important;
}

/* TH */
[id*="easy-discounts-table"] th,
div[id^="easy-discounts-table-"] th {
  color: ${headerText} !important;
  text-align: ${textAlign} !important;
  text-transform: uppercase !important;
  letter-spacing: .02em !important;
  font-weight: 700 !important;
  font-size: 14px !important;
  padding: 14px 10px !important;
  background-clip: padding-box !important;
  vertical-align: middle !important;
  ${showColumnBorders ? `border-right: ${borderWidth}px ${borderStyle} ${unifiedColor} !important;` : 'border-right: 0 !important;'}
}
[id*="easy-discounts-table"] thead th:not(:last-child)::after,
div[id^="easy-discounts-table-"] thead th:not(:last-child)::after {
  content: "" !important;
  position: absolute !important;
  right: 0; top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 64%;
  background-color: ${unifiedColor} !important;
  border-radius: 999px;
}
[id*="easy-discounts-table"] thead th:last-child,
div[id^="easy-discounts-table-"] thead th:last-child { border-right: 0 !important; }

/* TD — chỉ kẻ NGANG bằng màu hợp nhất */
[id*="easy-discounts-table"] td,
div[id^="easy-discounts-table-"] td {
  padding: 14px 10px !important;
  text-align: ${textAlign} !important;
  ${showColumnBorders ? `border-right: ${borderWidth}px ${borderStyle} ${unifiedColor} !important;` : 'border-right: 0 !important;'}
  border-top: ${showRowBorders ? `${borderWidth}px ${borderStyle} ${unifiedColor}` : '0'} !important;
  border-bottom: 0 !important;
  background-clip: padding-box !important;
  vertical-align: middle !important;
}
/* Hàng đầu tiên không có line trên cùng */
[id*="easy-discounts-table"] tbody tr:first-child td,
div[id^="easy-discounts-table-"] tbody tr:first-child td {
  border-top: 0 !important;
}

/* Cột giá cuối — chỉ đổi màu, giữ weight bình thường */
${highlightDiscount ? `
[id*="easy-discounts-table"] td:last-child,
div[id^="easy-discounts-table-"] td:last-child {
  color: ${priceColor} !important;
  font-weight: var(--text-font-weight-default, 400) !important;
}
` : ''}

/* Padding (nhắc lại theo size) */
[id*="easy-discounts-table"] th,
[id*="easy-discounts-table"] td,
div[id^="easy-discounts-table-"] th,
div[id^="easy-discounts-table-"] td {
  padding: ${padding} !important;
}

/* Tắt hover */
[id*="easy-discounts-table"] tbody tr:hover,
div[id^="easy-discounts-table-"] tbody tr:hover {
  background: transparent !important;
}

/* Striped (nếu chọn) */
${tableStyle === 'striped' ? `
[id*="easy-discounts-table"] tbody tr:nth-child(even),
div[id^="easy-discounts-table-"] tbody tr:nth-child(even) {
  background: ${unifiedColor}1A !important; /* ~10% alpha nếu trình duyệt hỗ trợ */
}
` : ''}
`;

      styleElement.textContent = css;
    });
  }

  // Gỡ "Table description" ở container hiện tại (nằm TRƯỚC <table>)
  function removeDescription(container, table) {
    // 1) Thử theo các class/attr phổ biến của app
    const selectors = [
      '.easy-discounts-table-description',
      '.easy-discounts-description',
      '.discount-table-description',
      '[data-easy-discounts-description]'
    ];
    let descEl = null;
    for (const sel of selectors) {
      descEl = container.querySelector(sel);
      if (descEl) break;
    }
    // 2) Nếu không có class, dò phần tử đứng trước table có nền khác transparent
    if (!descEl) {
      const children = Array.from(container.children);
      const idx = children.indexOf(table);
      if (idx > 0) {
        const prev = children[idx - 1];
        const bg = getComputedStyle(prev).backgroundColor;
        const txt = (prev.textContent || '').trim();
        if ((bg && bg !== 'rgba(0, 0, 0, 0)') || txt.length) descEl = prev;
      }
    }
    if (descEl) descEl.remove();
  }

  // Lần chạy đầu
  applyUnifiedSkin();

  // Re-apply khi app chèn bảng lại
  const observer = new MutationObserver((mutations) => {
    let shouldReapply = false;
    mutations.forEach((m) => {
      m.addedNodes && m.addedNodes.forEach((node) => {
        if (node.nodeType === 1 && node.id && typeof node.id === 'string' && node.id.includes('easy-discounts-table')) {
          shouldReapply = true;
        }
      });
    });
    if (shouldReapply) {
      setTimeout(() => {
        applyUnifiedSkin();
      }, 100);
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
});